import type { Method } from 'lib/axios';

import { APICallV4 } from '../APICall';

interface RespData {
    attempts_available: number;
    end_time?: number;
}

export class ImproveImageAttemptsApiCall extends APICallV4<RespData> {
    _method = 'improve/image/attempts';
    _type: Method = 'get';
}

export const improveImageAttemptsApiCall = () => new ImproveImageAttemptsApiCall().makeRequest();
